module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.3 19"><path d="M42.3 9.5c0-.6-.4-1-1-1H14L17.1 0C12.7 3.8 5.7 7.4 0 9.5c5.7 2.1 12.7 5.7 17.1 9.5L14 10.5h27.3c.6 0 1-.4 1-1z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow.svg
// module id = 4
// module chunks = 0